module.exports = __webpack_public_path__ + "img/icon-ve.cbf82c89.svg";